import { configs } from "@/configs";
import { api } from "@/client/api";

export async function getDashboardUrl(type = "") {
  const { data } = await api.get<{
    data: string;
  }>(`${configs.apiUrl}/dashboard/${type}`);
  return data;
}
